<template>
  <div class="sale-change-subscription">
    <p class="mb-4">
      Esta nova data de cobrança será válida para as próximas cobranças ainda
      não agendadas.
    </p>
    <snow-select
      v-model="form.day"
      :errors="errors.day"
      id="day"
      label="Data de cobrança"
      :options="options"
    />
    <div class="snow-submit-buttons mt-7">
      <snow-button
        text="Cancelar"
        variant="gray"
        size="lg"
        @click="$emit('close')"
      />
      <snow-button
        text="Salvar"
        type="submit"
        :loading="loading"
        size="lg"
        @click="reBillet"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import get from "lodash/get";

export default {
  props: {
    item: {
      type: Number,
      required: true
    }
  },
  data() {
    const padStart = n => `${n}`.padStart(2, "0");
    return {
      ...formFields(["day"]),
      options: Array(31)
        .fill(0)
        .map((val, index) => index + 1)
        .map(val => ({ id: padStart(val), name: padStart(val) }))
    };
  },
  methods: {
    reBillet() {
      this.loading = true;
      window.axios
        .post(`/subscriptions/change-next-billing-at/${this.item}`, this.form)
        .then(response => {
          this.$message.success("Pagamento configurado com sucesso");
        })
        .catch(error => {
          this.$message.error(
            get(error, "response.data.message", "Erro ao configurar pagamento")
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
